import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {WhyChooseAarniComponent} from "./why-choose-aarni/why-choose-aarni.component";
import {InternationalAdmissionsComponent} from "./international-admissions.component";
import {ScholarshipComponent} from "./scholarship/scholarship.component";
import {ProgramFeeComponent} from "../admissions/program-fee/program-fee.component";
import {HostelFeeComponent} from "../admissions/hostel-fee/hostel-fee.component";
import {InternationalApplyComponent} from "./international-apply/international-apply.component";
import {ApplyFormComponent} from "../form/apply-form/apply-form.component";

const routes: Routes = [
    {path: 'why-choose-arni', component: WhyChooseAarniComponent},
    {path: 'program-fee', component: InternationalAdmissionsComponent, data: {title: 'International Program Fee'}},
    {path: 'hostel-fee', component: InternationalAdmissionsComponent, data: {title: 'International Hostel Fee'}},
    {path: 'apply-form', component:ApplyFormComponent , data: {title: 'How To Apply'}},

    {path: 'admission-rules', component: InternationalAdmissionsComponent, data: {title: 'Admission Rules'}},
    {path: 'payment-procedure', component: InternationalAdmissionsComponent, data: {title: 'Payment Procedure'}},
    {path: 'scholarship', component: ScholarshipComponent},
    {path: 'faqs', component: InternationalAdmissionsComponent, data: {title: 'Faqs'}},
    {path: 'admission-flow', component: InternationalAdmissionsComponent, data: {title: 'Admission Flow'}},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InternationalAdmissionsRoutingModule { }
